import React from "react";
import Login from "../features/user/LoginUser";
import ProfileCompletion from "../features/profile/ProfileCompletion";
import SignUp from "../features/user/SignupUser";
import VerifyUser from "../features/user/VerifyUser";
import JobRelatedInfo from "../features/profile/JobRelatedInfo";
import DesiredJobType from "../features/profile/DesiredJobType";
import CandidateProfile from "../features/profile/CandidateProfile";
import InterviewListing from "../features/interview/InterviewListing";
import ChatSec from "../features/chats/ChatSec";
import Jobs from "../features/jobs/Jobs";
import JobDescription from "../features/jobs/JobDescription";
import TestCenter from "../features/testCenter/TestCenter";
import TestQuestions from "../features/testCenter/TestQuestions";
import ForgotPassword from "../features/user/ForgotPassword";
import ResetPassword from "../features/user/ResetPassword";
import VerificationCode from "../features/user/VerificationCode";
import UserVerified from "../features/user/UserVerified";
import ChangePassword from "../features/user/ChangePassword";

interface RoutePathDefinition {
  title?: string;
  children?: RoutePathDefinition[];
  path: string;
  element?: React.ReactNode | null;
}
//
export const appRoutes: RoutePathDefinition[] = [
  {
    path: "/",
    children: [
      {
        path: "auth",
        title: "AUTH",
        children: [
          {
            path: "signup",
            element: <SignUp />,
          },

          {
            path: "login",
            element: <Login />,
          },

          {
            path: "forgot_password",
            element: <ForgotPassword />,
          },

          {
            path: "verification_code",
            element: <VerificationCode />,
          },

          {
            path: "reset_password",
            element: <ResetPassword />,
          },
          {
            path: "verify_user",
            element: <VerifyUser />,
          },

          {
            path: "user_verified/:email_token",

            element: <UserVerified />,
          },

          {
            path: "profile",
            element: <CandidateProfile />,
          },
        ],
      },

      {
        path: "changePassword",
        element: <ChangePassword />,
      },

      {
        path: "testCenter",
        element: <TestCenter />,
      },

      {
        path: "chats",
        element: <ChatSec />,
      },

      {
        path: "interviews",
        element: <InterviewListing />,
      },

      {
        path: "/",
        element: <Jobs />,
      },
      {
        path: "jobs/job-description",
        element: <JobDescription />,
      },

      // {
      //   path: "test/test-description",
      //   element: <TestDescription />,
      // },

      {
        path: "testCenter/test-questions",
        element: <TestQuestions />,
      },

      {
        path: "profile",
        title: "PROFILE",
        children: [
          {
            path: "basic",
            element: <ProfileCompletion />,
          },
          {
            path: "desired_job",
            element: <DesiredJobType />,
          },
          {
            path: "job_related_info",
            element: <JobRelatedInfo />,
          },
        ],
      },
    ],
  },
];
